import { colors } from '@lmc/common/constants'
import React from 'react'
import { Icon } from '../../../../components/generic'

export const SuccessMessage = () => (
  <div style={styles.successContainer}>
    <Icon
      fill={colors.green}
      name="tick-in-circle"
      size={80}
      style={styles.successIcon}
    />
    <span>Woo! You're up to date!</span>
  </div>
)

const styles = {
  successContainer: {
    alignItems: 'center',
    fontSize: 16,
    fontWeight: 600,
    display: 'flex',
    width: '100%'
  }
}

export default SuccessMessage
